<template>
  <!--
  * Copyright (c) 2014-2020 Zuoyebang, All rights reseved.
  * @fileoverview 邀请拉新端内页面
  * @author zhaoxinran | zhaoxinran@zuoyebang.com
  * @version 1.0 | 2020-01-06 | zhaoxinran   // 初始版本
  -->
  <div v-log:once="`name=KD_C31_0_1`" class="invitenewapp">
    <div class="btn-rule" @click="showWindow = 'rule'"></div>
    <section class="share-container">
      <div v-log-click="`KD_C31_0_2`" class="btn-share qq" @click="handlerShare('1')"></div>
      <div v-log-click="`KD_C31_0_2`" class="btn-share wechat" @click="handlerShare('4')"></div>
    </section>
    <h3 class="page-title">奖励进度</h3>
    <section class="cash-container">
      <ul class="progress-list">
        <li class="progress-item">
          <p class="progress-item-num">
            <span class="bigger">{{ shareNum }}</span>
            人
          </p>
          <p class="progress-item-status">在路上</p>
        </li>
        <li class="progress-item">
          <p class="progress-item-num">
            <span class="bigger">{{ userInfo.remainMoney }}</span>
            元
          </p>
          <p class="progress-item-status">待领取</p>
        </li>
        <li class="progress-item">
          <p class="progress-item-num">
            <span class="bigger">{{ userInfo.receivedMoney }}</span>
            元
          </p>
          <p class="progress-item-status">已领取</p>
        </li>
      </ul>
      <p class="cash-content">
        可提现金额：
        <span class="red">{{ allowAcquireMoney }}元</span>
      </p>
      <div class="btn-cash" @click="handlerOpenCash">提现</div>
    </section>
    <section v-show="showWindow.length > 0" class="mask" @touchmove.prevent>
      <div v-if="showWindow === 'share'" v-log="`KD_C31_2_1`" class="window window-share">
        <div class="btn-close" @click="showWindow = ''"></div>
        <h3 class="share-title">
          您不是新用户啦
          <br />
          <span class="red">快去邀请新用户赚赏金吧</span>
        </h3>
        <p class="share-tip">
          每邀请一名新用户
          <br />
          最高可得10元，必得1元
        </p>
        <div class="share-btn-container">
          <div v-log-click="`KD_C31_2_2`" class="btn-share qq" @click="handlerShare('1')">QQ</div>
          <div v-log-click="`KD_C31_2_2`" class="btn-share wechat" @click="handlerShare('4')">微信</div>
        </div>
      </div>
      <div v-if="showWindow === 'cash'" class="window window-cash">
        <div class="btn-close" @click="showWindow = ''"></div>
        <section class="cash-content">
          <h3 class="cash-title">
            恭喜获得
            <span class="highlight">{{ allowAcquireMoney }}元</span>
            话费
          </h3>
          <input v-model="userInfo.phone" class="ipt-cash" type="text" placeholder="点击输入手机号" />
          <p class="cash-tips">请填写本人真实联系方式用于话费奖励充值</p>
          <div class="btn-cash" @click="handlerSubmit">提现</div>
        </section>
      </div>
      <div v-if="showWindow === 'rule'" class="window window-rule">
        <div class="btn-close" @click="showWindow = ''"></div>
        <p>1、好友进入你分享的页面，首次下载注册“快对作业”，即为邀请成功!</p>
        <p>
          2、每成功邀请1个好友，你和好友均可获得1元~10元金额不等的话费，最低可得1元，最高可得10元，用户邀请记录最多可保留6个月。
        </p>
        <p>3、话费提现不设门槛，1元话费即可提现，也可累计后一起提现。</p>
        <p>4、话费每日提现总限额20000元话费，先到先得，话费奖励将每7个工作日统一发放一次。</p>
        <p>5、每7个工作日内获得话费奖励未主动申请提现的和申请提现后手机号码填写有误的将不予发放奖励。</p>
        <p>6、若以任何形式作弊获得奖励的，主办方将不予发放。</p>
        <p>
          7、电信运营商提现最低限额为5元，建议用户变换移动或联通运营商参与活动，或采用积攒话费的形式参与活动，话费暂不支持虚拟运营商充值、以及166、199、198新号段充值。
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import '@w/utils/TCaptcha';
import { isPhone } from '@w/utils/common';
import Generate from '@w/utils/generate';
export default {
  name: 'InviteNewApp',
  data() {
    return {
      activityInfo: {
        actId: '' // 活动ID
      },
      userInfo: {
        isLogin: 0, // 登录状态,1登录,0未登录
        invitationCode: '', // 邀请码
        phone: '', // 上次提取话费的手机号
        receivedMoney: '-', // 已提取话费
        remainMoney: '-' // 待领取话费
      },
      showWindow: '',
      captcha: null // 腾讯验证码
    };
  },
  computed: {
    // 分享码
    shareCode() {
      return this.$route.query.code;
    },
    // 可领取金额
    allowAcquireMoney() {
      if (Number(this.userInfo.remainMoney) >= 0) {
        return Math.floor(this.userInfo.remainMoney);
      } else {
        return '-';
      }
    },
    // 分享人数
    shareNum() {
      if (this.activityInfo.actId.length > 0 && this.userInfo.isLogin) {
        // 已获得活动id && 用户已登录
        return this.getShareNum();
      } else {
        return '-';
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 页面初始化
    async init() {
      await this.fetchPageData(); // 获取页面初始数据
      if (typeof this.shareCode === 'string' && this.shareCode.length > 0) {
        // 被邀请来的用户
        this.userInfo.remainMoney = 1;
        if (parseInt(this.userInfo.isLogin) === 1) {
          // 用户已登录
          this.submitSharecode();
        } else {
          // 用户未登录
          this.showWindow = 'cash'; // 展示提现弹窗
          this.hybrid('login', { isReload: false }, async () => {
            this.userInfo.isLogin = 1;
            await this.fetchPageData(); // 获取页面初始数据
            this.submitSharecode();
          });
        }
      }
    },
    // 分享
    handlerShare(channel) {
      if (parseInt(this.userInfo.isLogin) === 1) {
        // 用户已登录
        this.share(channel);
      } else {
        // 用户未登录
        this.hybrid('login', { isReload: false }, async () => {
          this.userInfo.isLogin = 1;
          await this.fetchPageData(); // 获取页面初始数据
          this.share(channel);
        });
      }
    },
    // 打开提现窗口
    handlerOpenCash() {
      if (parseInt(this.userInfo.isLogin) === 1) {
        // 用户已登录
        if (this.allowAcquireMoney <= 0) {
          this.hybrid('toast', { text: '您暂时没有可以领取的话费，快去邀请新用户吧~' });
        } else {
          this.showWindow = 'cash'; // 展示提现弹窗
        }
      } else {
        // 用户未登录
        this.hybrid('login', { isReload: false }, async () => {
          this.userInfo.isLogin = 1;
          await this.fetchPageData(); // 获取页面初始数据
          if (this.allowAcquireMoney <= 0) {
            this.hybrid('toast', { text: '您暂时没有可以领取的话费，快去邀请新用户吧~' });
          } else {
            this.showWindow = 'cash'; // 展示提现弹窗
          }
        });
      }
    },
    // 提交提现信息
    handlerSubmit() {
      if (parseInt(this.userInfo.isLogin) === 1) {
        // 用户已登录
        this.checkPhoneNumber(this.userInfo.phone, () => {
          this.cash();
          this.showWindow = '';
        });
      } else {
        // 用户未登录
        this.hybrid('login', { isReload: false }, async () => {
          this.userInfo.isLogin = 1;
          await this.fetchPageData(); // 获取页面初始数据
        });
      }
    },
    // 获取页面数据
    async fetchPageData() {
      const res = await this.$http.post(this.api.inviteNewHome);
      if (parseInt(res.data.actUserInfo.isLogin) === 1) {
        // 用户已登录状态下，用户数据才有值
        this.userInfo = res.data.actUserInfo;
      }
      this.activityInfo = res.data.actInfo;
    },
    // 加密跳回链接并分享
    share(channel) {
      const os = (function () {
        if (/Android/i.test(navigator.userAgent) && channel === '4') {
          return 1;
        } else {
          return 0;
        }
      })();
      const link = `${window.location.protocol}//${window.location.hostname}/kdactivity/inviteNew.html#/app/?code=${this.userInfo.invitationCode}`;
      this.setShareNum();
      this.hybrid('shareToChannel', {
        shareTitle: '送你10元话费，即刻可提现',
        shareText: '限时领取>>',
        shareImg: 'http://kw1-1253445850.file.myqcloud.com/upload/share_logo.png',
        shareUrl: `${window.location.protocol}//${
          window.location.hostname
        }/kdactivity/inviteNew.html#/web/?os=${os}&link=${encodeURIComponent(link)}`,
        shareType: 'web',
        shareChannel: channel // 1qq好友2qq空间3微信朋友圈4微信好友  字符串类型
      });
    },
    // 提现
    cash() {
      /* eslint-disable  no-new */
      this.captcha = new window.TencentCaptcha('2029379714', async result => {
        if (result.ret === 0) {
          const res = await this.$http.post(this.api.getprize, {
            phone: this.userInfo.phone,
            ticket: result.ticket,
            randStr: result.randstr
          });
          if (parseInt(res.data.resNo) === 3) {
            // 当日限额用完
            this.hybrid('toast', { text: '当日限额用完，明日早点来哦~' });
          } else if (parseInt(res.data.resNo) === 1) {
            // 提现失败
            this.hybrid('toast', { text: '啊哦~提现失败了，请再试一次吧' });
          } else if (parseInt(res.data.resNo) === 0) {
            // 提现成功
            this.hybrid('toast', { text: '恭喜您提现成功~' });
            this.fetchPageData();
          }
        }
      });
      this.captcha.show();
    },
    // 提交邀请码，并获得是否是新用户
    submitSharecode() {
      /* eslint-disable no-new */
      this.hybrid('common', {}, async res => {
        const timeD5 = new Generate({ invitecode: this.shareCode, cuid: res.cuid, requestAct: 'setcode' });
        const resData = await this.$http.post(this.api.setcode, {
          cuid: res.cuid,
          invitecode: this.shareCode,
          ftime: timeD5.ftime,
          fkey: timeD5.fkey
        });
        if (parseInt(resData.data.setRes) !== 0) {
          // 不是新用户
          this.showWindow = 'share';
          await this.fetchPageData(); // 获取页面初始数据
        } else {
          this.showWindow = 'cash';
          this.hybrid('toast', { text: resData.data.setTips });
          this.logger.send({ name: 'KD_C38_0_2' });
        }
      });
    },
    // 从localStorage里取分享人数
    getShareNum() {
      let shareInfo = localStorage.getItem('shareInfo');
      if (shareInfo !== null) {
        shareInfo = JSON.parse(shareInfo);
      }
      if (shareInfo !== null && typeof shareInfo.id === 'string' && shareInfo.id === this.activityInfo.actId) {
        // 已经有localstorage且当前活动id一致，直接获取已分享人数
        return shareInfo.shareNum;
      } else {
        localStorage.setItem(
          'shareInfo',
          JSON.stringify({
            id: this.activityInfo.actId,
            shareNum: 0
          })
        );
        return 0;
      }
    },
    // 向localStorage里记录分享人数
    setShareNum() {
      localStorage.setItem(
        'shareInfo',
        JSON.stringify({
          id: this.activityInfo.actId,
          shareNum: this.getShareNum() + 1
        })
      );
    },
    // 校验手机号码
    checkPhoneNumber(phone, success) {
      if (!isPhone(phone)) {
        this.hybrid('toast', { text: '请输入正确的手机号' });
      } else if (
        /^(133|153|180|181|189|173)\d{8}$/.test(phone) &&
        (this.allowAcquireMoney < 5 || this.allowAcquireMoney === '-')
      ) {
        this.hybrid('toast', { text: '电信用户5元以上才可以提现哦~' });
      } else if (/^(166|177|199|198)\d{8}$/.test(phone)) {
        this.hybrid('toast', { text: '您的手机号暂不支持提现，请更换其他手机号~' });
      } else {
        success();
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../../assets/base');
.invitenewapp {
  .red {
    color: #ff431a;
    font-weight: normal;
  }
  .block-setting(720px, 100%,linear-gradient(135deg,#EC2670,#FF4161));
  position: relative;
  overflow: scroll;
  .btn-rule {
    .block-setting(133px, 48px, url(./resource/btn-rule.png) center / 100% no-repeat);
    .absolute(@right: 0, @top: 16px);
    z-index: 9;
  }
  .share-container {
    .block-setting(100%, 966px, url(./resource/bg-header.png) center / 100% no-repeat);
    position: relative;
    .btn-share {
      .block-setting(240px, 81px);
      .absolute(@bottom: 61px);
      &.qq {
        background: url(./resource/btn-share-qq.png) center / 100% no-repeat;
        left: 90px;
      }
      &.wechat {
        background: url(./resource/btn-share-wechat.png) center / 100% no-repeat;
        right: 90px;
      }
    }
  }
  .page-title {
    .font-setting(#fff, 36px, 36px, center);
    margin: 41px 0 22px;
    position: relative;
    &:before {
      content: '/ / / /';
      .absolute(@left: 160px);
      .font-setting(#FAC289, 20px, 36px);
    }
    &:after {
      content: '/ / / /';
      .absolute(@right: 160px);
      .font-setting(#FAC289, 20px, 36px);
    }
  }
  .cash-container {
    .block-setting(656px, 328px, #fff, 16px);
    overflow: hidden;
    margin: 0 auto 100px;
    .progress-list {
      .block-setting(100%, 166px, #FCF4EE);
      .progress-item {
        .block-setting(33.33%, 100%);
        padding-top: 58px;
        position: relative;
        float: left;
        &:not(:last-of-type) {
          &:after {
            content: '';
            .block-setting(1px, 120px, #EAD6D4);
            .absolute(@right: 0, @top: 23px);
            z-index: 9;
          }
        }
        .progress-item-num {
          .font-setting(#FF431A, 30px, 30px, center);
          .bigger {
            font-size: 64px;
          }
        }
        .progress-item-status {
          .font-setting(#3c444d, 22px, 54px, center);
        }
      }
    }
    .cash-content {
      .font-setting(#3c444d, 30px, 78px, center, 600);
    }
    .btn-cash {
      .block-setting(160px, 60px, linear-gradient(0deg,rgba(255,41,59,0.9),rgba(254,98,98,0.9)), 30px);
      .font-setting(#fff, 30px, 60px, center);
      box-shadow: 0px 10px 20px 0px rgba(182, 0, 60, 0.2);
      margin: 0 auto;
    }
  }
  .mask {
    .block-setting(100%, 100%, rgba(0,0,0,0.4));
    .absolute(fixed, @top: 0, @left: 0);
    z-index: 99;
    .window {
      .center-middle-setting;
    }
    .btn-close {
      .block-setting(20px, 20px, url(../../assets/images/icon-close-gray.png) center / 100% no-repeat);
      .absolute(@right: 20px, @top: 20px);
    }
    .window-share {
      padding-top: 76px;
      .block-setting(620px, 498px, #fff, 30px);
      .share-title {
        .font-setting(#333, 36px, 48px, center);
        margin-bottom: 48px;
      }
      .share-tip {
        .font-setting(#333, 26px, 34px, center);
        position: relative;
        &:before {
          content: '';
          .block-setting(110px, 2px, rgba(51, 51, 51, 0.1));
          .absolute(@left: 40px, @top: 30px);
        }
        &:after {
          content: '';
          .block-setting(110px, 2px, rgba(51, 51, 51, 0.1));
          .absolute(@right: 40px, @top: 30px);
        }
      }
      .share-btn-container {
        .block-setting(308px, 144px);
        margin: 38px auto 0;
        .btn-share {
          .block-setting(100px, 100%);
          .font-setting(#666, 22px, 22px, center);
          padding-top: 122px;
          &.qq {
            float: left;
            background: url(./resource/icon-qq.png) top / 100% no-repeat;
          }
          &.wechat {
            float: right;
            background: url(./resource/icon-wechat.png) top / 100% no-repeat;
          }
        }
      }
    }
    .window-cash {
      .block-setting(620px, 614px, transparent url(./resource/bg-window-cash.png) top center / 100% no-repeat);
      padding-top: 200px;
      transform: translate(-50%, -80%);
      .btn-close {
        top: 220px;
        background-image: url(../../assets/images/icon-close-white.png);
      }
      .cash-content {
        .block-setting(620px,414px, #FF5A5A, 30px);
        padding-top: 58px;
        .cash-tips {
          text-align: center;
          font-size: 0.24rem;
          color: #fff;
          margin-bottom: 10px;
        }
        .cash-title {
          position: relative;
          .font-setting(#fff, 36px, 48px, center);
          .highlight {
            color: #fff000;
            &:before {
              content: '';
              .block-setting(60px, 1px, #fff);
              .absolute(@left: 80px, @top: 24px);
            }
            &:after {
              content: '';
              .block-setting(60px, 1px, #fff);
              .absolute(@right: 80px, @top: 24px);
            }
          }
          &:before {
            content: '';
            .block-setting(8px, 8px, #fff, 4px);
            .absolute(@left: 150px, @top: 20px);
          }
          &:after {
            content: '';
            .block-setting(8px, 8px, #fff, 4px);
            .absolute(@right: 150px, @top: 20px);
          }
        }
        .ipt-cash {
          display: block;
          .block-setting(520px,90px, #E04646, 45px);
          margin: 28px auto 16px;
          .font-setting(#fff, 30px, 30px, center);
          .placeholder(#FF8787);
          padding: 30px;
        }
        .btn-cash {
          .block-setting(300px, 80px, #FFF000, 40px);
          .font-setting(#333, 30px, 80px, center, bold);
          margin: 0 auto;
        }
      }
    }
    .window-rule {
      .block-setting(620px, 900px, #fff, 30px);
      padding: 48px 48px;
      p {
        .font-setting(#9e9e9e, 30px, 34px);
        margin: 10px 0;
      }
    }
  }
}
</style>
